import { alpha } from "@mui/material";
import { CSSProperties, makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";
import theme from "../../theme";

interface Props {
    color: string;
    size?: number;
    className?: string;
    showBorder?: boolean;
}

const useStyles = makeStyles(() => ({
    root: {
        height: "0",
        width: "100%",
        paddingBottom: "100%",
        borderRadius: "50%",
        display: "block"
    }
}));

const ColorDot: React.FC<Props> = props => {
    const classes = useStyles();

    const style: CSSProperties = {
        backgroundColor: props.color,
        border: props.showBorder ? `1px solid ${alpha(theme.palette.getContrastText(props.color), 0.2)}` : undefined
    };

    if (props.size !== undefined) {
        style.width = `${props.size}px`;
        style.height = `${props.size}px`;
        style.paddingBottom = "initial";
    }

    return (
        <span
            className={clsx(classes.root, props.className)}
            style={style} />
    );
};

export default ColorDot;
